import * as yup from 'yup'
import { errorMsg, getPasswordComplexity } from '.'

/**
 * This schema used by Reset Password and Expired Password module
 * @param {number} passwordComplexityMinLength
 */
const resetAndExpiredPasswordSchema = (
  passwordComplexityMinLength: number,
) => ({
  newPassword: yup
    .string()
    .required(errorMsg.requiredField('Enter new password'))
    .test(
      'new password complexity test',
      "New password doesn't meet the requirement.",
      function (value) {
        const { isPasswordComplex } = getPasswordComplexity(
          value,
          passwordComplexityMinLength,
        )

        return Boolean(isPasswordComplex)
      },
    ),
  repeatPassword: yup
    .string()
    .required(errorMsg.requiredField('Confirm new password'))
    .test(
      'match password test',
      'Passwords do not match. Please try again.',
      function (value) {
        const { isPasswordComplex } = getPasswordComplexity(
          value,
          passwordComplexityMinLength,
        )

        const newPassword = this.parent.newPassword
        const isBothPasswordMatches = newPassword === value

        return Boolean(isPasswordComplex && isBothPasswordMatches)
      },
    ),
})

export default resetAndExpiredPasswordSchema
